class CommerceNavigation {
    constructor() {
        document.addEventListener('click', (e) => {
            if (e.ctrlKey || e.metaKey) {
                return true;
            }

            let target = e.target.nodeName === 'A' ? e.target : e.target.parentNode;

            // If we have a target, let the browser do its normal thing
            if (!target || target.getAttribute('target') === '_blank') {
                return true;
            }

            // Allow jsnav to be explicitly ignored on any link
            if (target.matches('.commerce-ignore-jsnav')) {
                return true;
            }

            // Match clicks on the top nav
            if (target.matches('#commerce-top-nav a') || (target.parentNode && target.parentNode.matches('#commerce-top-nav a'))) {
                e.preventDefault();
                let prevActive = document.getElementById('commerce-top-nav').querySelector('.active');
                if (prevActive) {
                    prevActive.classList.remove('active');
                }
                target.classList.add('active');

                this.navigateFullPage(target.getAttribute('href'));
                return false;
            }

            // Side nav
            else if (target.matches('#commerce-side-nav a') || (target.parentNode && target.parentNode.matches('#commerce-side-nav a'))) {
                e.preventDefault();
                let prevActive = document.getElementById('commerce-side-nav').querySelector('.active');
                if (prevActive) {
                    prevActive.classList.remove('active');
                }
                target.classList.add('active');

                let url = target.getAttribute('href');

                this.navigateFullPage(url);
                return false;
            }

            // Links elsewhere with the commerce-ajax-fullpage class
            else if (target.matches('.commerce-ajax-fullpage')) {
                e.preventDefault();
                this.navigateFullPage(target.getAttribute('href'));
                return false;
            }
        });

        // Restore the page that the popstate says we're on
        let that = this;
        window.onpopstate = function() {
            if (window.location.href.indexOf('namespace=commerce') !== -1) {
                that.navigateFullPage.bind(that)(window.location.href, false);
            }
            else {
                window.location = window.location.href;
            }
        };
    }

    refresh () {
        this.navigateFullPage(window.location.href);
    }

    navigateFullPage (url, updateHistory) {
        if (url.indexOf('namespace=commerce') === -1) {
            window.location = url;
            return;
        }
        // If needed, update the history
        updateHistory = updateHistory !== false;
        if (updateHistory && window.history) {
            window.history.pushState(null, document.title, url);
        }
        let loader = Commerce.container.querySelector('.commerce-page-loader');
        loader.classList.add('active');

        Commerce.Request.get(url + '&_commerce_ajax_full=1', {
            onSuccess: function(response) {
                let responseDom = document.createRange();
                responseDom = responseDom.createContextualFragment(response);

                // Grab the title for the page and update it
                let titleDom = responseDom.querySelector('#commerce-header'),
                    title = titleDom ? titleDom.innerText || titleDom.textContent : 'Commerce';
                title.replace("/\n\t/", "").replace('&raquo;', '»');

                if (title.length && updateHistory && window.history) {
                    window.history.replaceState(null, title, url);
                }
                if (window.MODx && window.MODx.config && window.MODx.config.site_name) {
                    title += ' | ' + MODx.config.site_name;
                }
                document.title = title;

                // Update the container contents
                let container = responseDom.querySelector('.commerce-container');
                if (container) {
                    Commerce.container.innerHTML = '';
                    while (responseDom.firstChild) {
                        Commerce.container.appendChild(responseDom.firstChild);
                    }

                }
                else {
                    Commerce.container.innerHTML = response;
                }

                // Initiate dynamic components
                CommerceNavigation.initComponents(Commerce.container);
            }
        });
    }

    static initComponents (dom) {
        if (!dom) {
            return;
        }

        // Initiate grids inside the dom
        let grids = dom.querySelectorAll('.commerce-grid');
        if (grids.length > 0) {
            Commerce.Grid.initGrids(grids, Commerce.Grid);
        }

        // Enhance special field types
        Commerce.Fields.enhanceAll(dom);

        // Enhance stuff from modules
        for (let key in Commerce.Modules) {
            if (!Commerce.Modules.hasOwnProperty(key)) {
                continue;
            }
            let mod = Commerce.Modules[key];
            mod.onRender(dom);
        }

        // Resize the commerce container (which also includes the modal container) to ensure scrollability
        Commerce.resizeContainer();
    }
}
